import VueTypes from 'vue-types';
import { titledLinkProps } from '@/mikan/_shared/types/vueTypes/anchorLink';

export const adminToolBarLink = VueTypes.shape({
  icon: VueTypes.string.def(''),
  ...titledLinkProps,
});

export const adminToolBarLinks = VueTypes.arrayOf(adminToolBarLink);
